





<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>
<vs-card >
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

     

      </div>
    </vs-card>
    

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Etkinlik Sorgu Sonuçları</h3>
           <div class="marrig" >Toplam {{totalfiltered}} kayıt </div>
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
       

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-5/5">
          <div v-if="loading">Loading...</div>

          <!-- <vs-table stripe :data="list" class="gizliTablo">
            <template slot="header">
              <h3>Etkinlik Bilgileri</h3>
            </template>
            <template slot="thead">
             
                <vs-th>Düzenleyen Kişi</vs-th>
                <vs-th  class="fontt4">Etkinlik Türü</vs-th>
                <vs-th  class="fontt4">Etkinlik Adı</vs-th>
                <vs-th >Hedef Kitle</vs-th>
                <vs-th >Dil</vs-th>
                <vs-th >Başlangıç Tarihi</vs-th>
                <vs-th >Salon</vs-th>
                <vs-th >KapsamUl</vs-th>
                 <vs-th >Fon Türü</vs-th>
                  <vs-th >Gerçekleşme Şekli</vs-th>
                <vs-th>Kayıt Durumu</vs-th>

            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >
                
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.createdBy }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.eventType }}</div>
                </vs-td>
                  <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.target }}</div>
                </vs-td>
                
                   <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.selectedLanguages }}</div>
                </vs-td>
                  <vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.startDate }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.national }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.moneyType }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.place }}</div>
                </vs-td>
               
                 <vs-td :data="item">
                  <div class="fontOnay" color="red" @click="show(item, i)">{{ item.published=="Kaydedildi" ? "Kaydedildi" : item.published=="Reddedildi" ? "Reddedildi" : "Beklemede" }}</div>
                </vs-td>
               
                
              </vs-tr>
            </template>
          </vs-table> -->
           <vs-table stripe :data="filteredItems" :max-items='pageSize' pagination>
           
            <template slot="thead">
               <vs-th>Etkinlik ID</vs-th>
              <vs-th>Düzenleyen Kişi</vs-th>
                <vs-th  class="fontt4">Etkinlik Türü</vs-th>
                <vs-th  class="fontt4">Etkinlik Adı</vs-th>
                <vs-th >Hedef Kitle</vs-th>
                <vs-th class="fontt4">Dil</vs-th>
                <vs-th class="fontt4">Başlangıç Tarihi</vs-th>
                  <vs-th class="fontt4">Bitiş Tarihi</vs-th>
                <vs-th class="fontt4">Salon</vs-th>
                <vs-th >KapsamUl</vs-th>
                 <vs-th >Fon Türü</vs-th>
                  <vs-th >Gerçekleşme Şekli</vs-th>

            </template>
            <template slot-scope="{data}">
              <vs-tr  v-for="(item, i) in data" :key="i" >
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.appealId }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.createdBy }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.eventType }}</div>
                </vs-td>
                  <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.target }}</div>
                </vs-td>
                
                   <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.selectedLanguages }}</div>
                </vs-td>
                  <!--<vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>-->
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt22" @click="show(item, i)">{{ datefunc(item.startDate) }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt22" @click="show(item, i)">{{ datefunc(item.endDate) }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.national }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.moneyType }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.place }}</div>
                </vs-td>
                 
               
                
              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>

        <div class="tw-w-full lg:tw-w-1/5 lg:tw-pl-5">
          <!-- <vs-card v-if="selected">
         
            <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <div class="close-button" slot="header">
              <vs-row vs-justify="flex-end">
                <vs-button close type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" @click="func">X &nbsp</vs-button>
              </vs-row>
            </div>
            
            <div >
            
              <div>
                <strong>Durum: </strong> {{ selected.published ? "Kaydedildi" : "Kaydedilmedi" }}
              </div>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                    <vs-button v-if="selected.published" color="warning" @click="updatePublished(false)">Reddet</vs-button>
                    <vs-button class="butonlar" v-else color="primary" @click="updatePublished(true)">Onayla</vs-button> 
              </vs-row>
               
               

            </div>
          </vs-card>-->

          <!--<div v-else>
            <br />
            <vs-alert active="true" color="info">
              Onaylamak için etkinlik seçiniz.
            </vs-alert>
          </div>-->
        </div>
      </div>

    </vs-card>

  </div>
</template>

<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Appeal from "@/libs/appeals/Appeal";

  export default {
    name: "etkinlik-sonuclar",
    title: "Etkinlik Arama Sonuçları",

    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        obj: new Appeal(),
        search: "",
        filtreList:[],
        filtreCheckedList:[],
        loading: false,
        listeCheck:true,
            max:null,
            min:0,
            totalfiltered:0,
            items:[],
            aranacakSalon:'',
            aranacakTarih1:'',
            aranacakTarih2:'',
            aramaTemel:"",
            aramaTemelSonrasi:"",
            aramaTemelSonrasiDetay:"",
            aramaSergi:false,
            aramaAkademik:false,
            aramaIdari:false,
            aramaOgrenci:false,
            aramaDiger:false,
            aramaTurkce:false,
            aramaIngilizce:false,
            aramaArapca:false,
            aramaAlmanca:false,
            paraTl:false,
            paraDolar:false,
            paraEuro:false,
            paraSterlin:false,
            aramaKurumici:false,
            aramaKurumdisi:false,
            aramaUlusal:false,
            aramaUluslararasi:false,
            aramaGunluk:false,
            aramaAylik:false,
            aramaYillik:false,
            aramaHepsi:false,
            aramaHibrit:false,
            aramaDijital:false,
            aramaYuzyuze:false,
            aramaHepsi2:false,
            aramaOnayli:false,
            aramaOnaysiz:false,
            aramaHepsi3:false,
            aramaBirkez:false,
            aranacakId:'',
      };
    },

    computed: {
      appeals() {
        
        return this.obj.appeals
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },
      filteredItems () {
            return this.items.filter(item => {
              if(true){
                  if(this.salonFunc(item) && this.tarihFunc(item)  && this.turFunc(item)  && this.kitleFunc(item)  && this.dilFunc(item)  && this.fonFunc(item)  && this.kurumFunc(item)  && this.ulusalFunc(item)  && this.gunlukFunc(item)  && this.ortamFunc(item)  && this.durumFunc(item)  && this.idBulFunc(item)){
                      this.totalfiltered++
                      return true
                  }
                  
              }
              
               
              
             /*  if(this.searchEmail != ""){
                return item.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) > -1
              }
              if(this.searchBak){
                return item.balance > this.searchBak  
              }
               */
            })
          },
      list() {
      
        if(this.appeals && this.appeals.data){
           
           /*  if(this.listeCheck==true){
              
                 this.filtreList=this.appeals.data

            
            for (let i = 0; i < this.filtreList.length; i++) {
            



             if(
               this.salonFunc(this.filtreList[i]) && 
                this.tarihFunc(this.filtreList[i]) && 
                  this.turFunc(this.filtreList[i]) &&
                  this.kitleFunc(this.filtreList[i]) &&
                  this.dilFunc(this.filtreList[i]) &&
                  this.fonFunc(this.filtreList[i]) &&
                  this.kurumFunc(this.filtreList[i]) &&
                  this.ulusalFunc(this.filtreList[i]) &&
                  this.gunlukFunc(this.filtreList[i]) &&
                  this.ortamFunc(this.filtreList[i]) &&
                  this.durumFunc(this.filtreList[i]) &&
                  this.idBulFunc(this.filtreList[i])

             ){
              
                this.filtreCheckedList.push(this.filtreList[i]);
             }
               
                
              
              
            }
            this.listeCheck=false
            } */
            this.items=this.appeals.data
            
            return this.appeals.data
        }
          

        return []
      },

      meta() {
        if(this.appeals && this.appeals.meta)
          return this.appeals.meta

        return null
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },

    methods: {
      datefunc(temp){
        var date = ""+temp
        if(temp){
            if(date.length>2){
            var newerdate=date.substring(0,10)
            var newdate = newerdate.split("-").reverse().join("-");
            
            return newdate
        }else{
          return ""
        }
        }else{
          return "-"
        }
        
          

         
          
        
       },
      languageCevir(item){
        var temp=""
        if(item){
           for (let i = 0; i < item.length; i++) {
          temp += item[i]+" ";
        }
        }
       
        return temp;
      },
      etkinlikGoster(item,i){
          
          if(item.published =="Silindi"){         
            return false;
          }
          return true;
      },
      salonFunc(item){
            if(item.room!=null){
              console.log(item.room)
                if(this.aranacakSalon!=""){
              if(item.room.includes(this.aranacakSalon)){
                return true;
              }
              else{
                return false;
              }
            }else{
              return true;
            }
            }
            
      }, 
      idBulFunc(item){
            if(this.aranacakId!=""){
              console.log(this.aranacakId)
             
              if(item.appealId.includes(this.aranacakId.trim())){
                return true;
              }
              else{
                return false;
              }
            }else{
              return true;
            }
      }, 
      tarihFunc(item){
        
          var date1 = new Date(item.startDate);
          var date2 = new Date(item.endDate);
                 
                  var start = new Date(this.aranacakTarih1);
                  var end = new Date(this.aranacakTarih2);
                  if(this.aranacakTarih1!=this.aranacakTarih2){
                          if (date1 >= start && date2 <= end) {

                              console.log(' date is in the range!!');
                            return true;
                          
                          } else {
                           
                            //console.log(' date is not in the range');
                            return false;
                          }
                  }
                  else{
                    
                  return true;
                }
                  
      },
      turFunc(item){//buraya bakılacak 
            
             
              if( this.aramaTemelSonrasi.length>1){
                  if( this.aramaTemelSonrasiDetay.length>1){
                     
                      if(item.eventType.toLowerCase().indexOf(this.aramaTemelSonrasiDetay.toLowerCase()) > -1 || item.eventType.toLowerCase().indexOf(this.aramaTemelSonrasi.toLowerCase()) > -1){

                        return true;
                      }else{
                        return false
                        var e=2;
                      }
                  }else{
                       if(item.eventType.toLowerCase().indexOf(this.aramaTemelSonrasi.toLowerCase()) > -1){
                        return true;
                      }else{
                        return false
                        var e=2;
                      }
                  }
                    
                      
                
                
            }else{
              return true;
            }
            
         
      },
      kitleFunc(item){
          if(this.aramaDiger!=false){
            return true;
        }
        else{
          if(this.aramaOgrenci!=false){
            if(item.target=="Öğrenci"){
              return true;
            }else{
              return false;
            }
        }
        if(this.aramaIdari!=false){
            if(item.target=="İdari Personel"){
              return true;
            }else{
              return false;
            }
        }  
        if(this.aramaAkademik!=false){
            if(item.target=="Akademisyen"){
              return true;
            }else{
              return false;
            }
        } 
        return true;
        }
           
      },
      dilFunc(item){
          if( !this.aramaTurkce && !this.aramaIngilizce && !this.aramaAlmanca && !this.aramaArapca){
            return true;
          }
           if( this.aramaTurkce && this.aramaIngilizce && this.aramaAlmanca && this.aramaArapca){
            return true;
          }
          if(this.aramaTurkce!=false){
            for (let i = 0; i < item.selectedLanguages.length; i++) {
              if(item.selectedLanguages[i] == "Türkçe"){
                return true;
              }else{
                return false;
            }
            }
           }
        
        if(this.aramaAlmanca!=false){
           for (let i = 0; i < item.selectedLanguages.length; i++) {
              if(item.selectedLanguages[i] == "Almanca"){
                return true;
              }else{
                return false;
            }
            }
        }  
        if(this.aramaArapca!=false){
           for (let i = 0; i < item.selectedLanguages.length; i++) {
              if(item.selectedLanguages[i] == "Arapça"){
                return true;
              }else{
                return false;
            }
            }
        } 
        if(this.aramaIngilizce!=false){
            for (let i = 0; i < item.selectedLanguages.length; i++) {
              if(item.selectedLanguages[i] == "İngilizce"){
                return true;
              }else{
                return false;
            }
            }
        } 
       
        
           
     
      },
      fonFunc(item){  
          if(!this.paraTl && !this.paraDolar  && !this.paraEuro && !this.paraSterlin){
            return true;
        }
        if(this.paraTl && this.paraDolar && this.paraEuro && this.paraSterlin){
            return true;
        }
        else{
          if(this.paraTl!=false){
            if(item.moneyType=="Türk Lirası"){
              if(parseInt(item.fon) >= parseInt(this.min) && parseInt(item.fon) <= parseInt(this.max)){
                return true;
              }
                
              else{
                  return false;
              }  
                
            }else{
              return false;
            }
        }
        if(this.paraDolar!=false){
            if(item.moneyType=="Dolar"){
              console.log("dolar")
              if(parseInt(item.fon) >= parseInt(this.min) && parseInt(item.fon) <= parseInt(this.max)){
                return true;
              }
                
              else{
                  return false;
              }  
                
            }else{
              return false;
            }
        } 
        if(this.paraEuro!=false){
            if(item.moneyType=="Euro"){
              if(parseInt(item.fon) >= parseInt(this.min) && parseInt(item.fon) <= parseInt(this.max)){
                return true;
              }
                
              else{
                  return false;
              }  
                
            }else{
              return false;
            }
        }
        if(this.paraSterlin!=false){
            if(item.moneyType=="Sterlin"){
              if(parseInt(item.fon) >= parseInt(this.min) && parseInt(item.fon) <= parseInt(this.max)){
                return true;
              }
                
              else{
                  return false;
              }  
                
            }else{
              return false;
            }
        }  
        
        return true;
        }
      },
      kurumFunc(item){
          if(!this.aramaKurumdisi && !this.aramaKurumici){
            return true;
        }
        if(this.aramaKurumdisi && this.aramaKurumici){
            return true;
        }
        else{
          if(this.aramaKurumdisi!=false){
            if(item.institution=="Kurum Dışı"){
              return true;
            }else{
              return false;
            }
        }
        if(this.aramaKurumici!=false){
            if(item.institution=="Kurum İçi"){
              return true;
            }else{
              return false;
            }
        }  
        
        return true;
        }
      },    
      ulusalFunc(item){
          if(!this.aramaUlusal && !this.aramaUluslararasi){
            return true;
        }
        if(this.aramaUlusal && this.aramaUluslararasi){
            return true;
        }
        else{
          if(this.aramaUlusal!=false){
            if(item.national=="Ulusal"){
              return true;
            }else{
              return false;
            }
        }
        if(this.aramaUluslararasi!=false){
            if(item.national=="Uluslararası"){
              return true;
            }else{
              return false;
            }
        }  
        
        return true;
        }
      },

      
      gunlukFunc(item){ //sor
         if(this.aramaHepsi){
            return true;
        }
        else{
          if(this.aramaBirkez!=false){
            if(item.density=="Bir Kez"){
              return true;
            }else{
              return false;
            }
        }
        if(this.aramaGunluk!=false){
            if(item.density=="Günlük"){
              return true;
            }else{
              return false;
            }
        }  
        if(this.aramaAylik!=false){
            if(item.density=="Aylık"){
              return true;
            }else{
              return false;
            }
        } 
        if(this.aramaYillik!=false){
            if(item.density=="Aylık"){
              return true;
            }else{
              return false;
            }
        } 
        return true;
        }
         
      },
      ortamFunc(item){
        if(this.aramaHepsi2){
            return true;
        }
        else{
          if(this.aramaHibrit!=false){
            if(item.place=="Hibrit"){
              return true;
            }else{
              return false;
            }
        }
        if(this.aramaDijital!=false){
            if(item.place=="Dijital"){
              return true;
            }else{
              return false;
            }
        }  
        if(this.aramaYuzyuze!=false){
            if(item.place=="YüzYüze"){
              return true;
            }else{
              return false;
            }
        } 
        return true;
        }
           
        
      },
      
      durumFunc(item){
            if(this.aramaHepsi3){
                return true;
            }
            else{
              if(this.aramaOnayli!=false){
                if(item.published=="Kaydedildi"){
                  return true;
                }else{
                  return false;
                }
            }
            if(this.aramaOnaysiz!=false){
                if(item.published!="Kaydedildi"){
                  return true;
                }else{
                  return false;
                }
            }  
             
            return true;
            }
              },
      silmeYap(itemid) {

        this.$confirm(
        {
          message: `Etkinliği Silmek İstiyor Musunuz?`,
          button: {
            no: 'Hayır',
            yes: 'Evet'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             
              
        this.obj.delete(itemid)
            }
          }
        }
      )
        
      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          500 
        );

        this.loading = true
        this.obj.getAll(params)
        setTimeout(() => {
           this.items=this.obj.appeals.data
        }, 300)
        
      },
      
     
       updatePublished(status,item) {
        
        if(status==true){
         this.$confirm(
        {
          message: `Etkinliği Onaylamak İstiyor Musunuz?`,
          button: {
          
            yes: 'Evet',
              no: 'Hayır'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             this.obj.columns.published = true
              
        return this.uppub(item)
            }
          }
        }
      )
      }
      else{
          this.$confirm(
        {
          message: `Etkinliği Reddetmek İstiyor Musunuz?`,
          button: {
            
            yes: 'Evet',
            no: 'Hayır'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             
               this.obj.columns.published = false
        return this.uppub(item)
            }
          }
        }
      )
      }
       
      },

      update(item) {
        
        this.loading = true
        
        this.obj.columns.eventName=item.eventName
        this.obj.columns.eventType=item.eventType
         this.obj.columns.startDate=item.startDate
        this.obj.columns.startTime=item.startTime
         this.obj.columns.room=item.room
        this.obj.columns.eventType=item.eventType
         this.obj.columns.eventName=item.eventName
        this.obj.columns.relations=item.relations
        this.obj.columns.relatedEvent=item.relatedEvent
        
       
        this.obj.update(item.id, true)
      },


      handlePageChange(page) {
        this.page = page;
        this.get();
      },

      handlePageSizeChange() {
        this.page = 1;
        this.get();
      },

      refreshList() {
        this.get();
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        //this.loading = true
        this.obj.deleteAll()
      },
      
      uppub(item){
        this.update(item)
         this.loading = false
         console.log("loading")
      }
    },
    
    mounted() {
    
      this.get();
       

               this.aranacakSalon=this.$route.params.parametre1
                
               this.aranacakTarih1=this.$route.params.parametre2
               this.aranacakTarih2=this.$route.params.parametre3

               //this.aramaTemel=this.$route.params.parametre4
            
               this.aramaTemelSonrasi=this.$route.params.parametre5
               this.aramaTemelSonrasiDetay=this.$route.params.parametre6

               this.aramaSergi=this.$route.params.parametre7
               this.aramaAkademik=this.$route.params.parametre8
               this.aramaIdari=this.$route.params.parametre9
               this.aramaOgrenci=this.$route.params.parametre10
               this.aramaDiger=this.$route.params.parametre11
               this.aramaTurkce=this.$route.params.parametre12
               this.aramaIngilizce=this.$route.params.parametre13
               this.aramaArapca=this.$route.params.parametre14
               this.aramaAlmanca=this.$route.params.parametre15
               this.min=this.$route.params.parametre16
               this.max=this.$route.params.parametre17
               this.paraTl=this.$route.params.parametre18
               this.paraDolar=this.$route.params.parametre19
               this.paraEuro=this.$route.params.parametre20
               this.paraSterlin=this.$route.params.parametre21
               this.aramaKurumici=this.$route.params.parametre22
               this.aramaKurumdisi=this.$route.params.parametre23
               this.aramaUlusal=this.$route.params.parametre24
               this.aramaUluslararasi=this.$route.params.parametre25
               this.aramaGunluk=this.$route.params.parametre26

               this.aramaAylik=this.$route.params.parametre27
               this.aramaYillik=this.$route.params.parametre28
               this.aramaHepsi=this.$route.params.parametre29
               this.aramaHibrit=this.$route.params.parametre30
               this.aramaDijital=this.$route.params.parametre31
               this.aramaYuzyuze=this.$route.params.parametre32
               this.aramaHepsi2=this.$route.params.parametre33
               this.aramaOnayli=this.$route.params.parametre34
               this.aramaOnaysiz=this.$route.params.parametre35
               this.aramaHepsi3=this.$route.params.parametre36
               this.aramaBirkez=this.$route.params.parametre37
               this.aranacakId=this.$route.params.parametre38

               
    }
  };
</script>

<style>
  .vs-component.vs-button.vs-button-danger.vs-button-gradient{
    color:white;
  }
  .vs-component.vs-button.vs-button-primary.vs-button-filled{
    color:white;
  }
  .vs-component.vs-button.vs-button-null.vs-button-filled{
    color:white;
  }

  .header1 {display:inline-block;margin-right:10px;} 
.close1 {text-align: center;}
.fontt4{
  width:15%;
}

.fontt45{
   width:70px !important;
    font-size:12.8px !important;
    font-family:'Gotham-Medium' !important;
}
.gizliTablo{
  display:none;
}

.marrig{
  margin-right:4%;
  font-size:14px
}
.fontt22{
    width:90px;
  }
</style>